import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { baseStyles, textStyles, iconStyles, menuStyles, itemStyles } from './styles'

const Wrapper = styled('div')(baseStyles)
const Text = styled('span')(textStyles)
const Icon = styled('svg')(iconStyles)
const Menu = styled('div')(menuStyles)
const ItemElement = styled('span')(itemStyles)

function DropDown ({ children }) {
  const [open, setOpen] = useState(false)

  const toggle = () => setOpen(!open)

  useEffect(() => {
    if (open) {
      document.body
        .addEventListener('click', () => setOpen(false))
    }

    return () => {
      document.body.removeEventListener('click', setOpen)
    }
  }, [open])

  return (
    <Wrapper onClick={toggle}>
      <Icon viewBox="0 0 512 512">
        <circle cx="256" cy="256" r="64"></circle>
        <circle cx="256" cy="448" r="64"></circle>
        <circle cx="256" cy="64" r="64"></circle>
      </Icon>
      <Menu active={open}>{children}</Menu>
    </Wrapper>
  )
}

function Item ({ text, onClick }) {
  return (
    <ItemElement onClick={onClick}>
      <Text>{text}</Text>
    </ItemElement>
  )
}

DropDown.Item = Item

DropDown.propTypes = {
  children: PropTypes.node.isRequired
}

Item.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func
}

export default DropDown
